var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"lazyContent",style:(_vm.style)},[(_vm.isVisible)?_vm._t("default",null,{"isVisible":_vm.isVisible}):_vm._e(),(!_vm.isVisible && !_vm.hideLoader)?_c('loader',{style:(_vm.styleLoader),attrs:{"size":"medium","has-overlay":true,"margin-top":_vm.topLoader}},[_c('div',{staticClass:"loading"})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }